import { WebhookGatewayMessage } from '../../../../../types/WebhookMessages';
import { Button } from '../../../../cdl/Button/Button';
import { Modal } from '../../../../cdl/Modal/Modal';
import { Text } from '../../../../cdl/Text/Text';
import { useToasts } from '../../../../cdl/Toast/useToasts';
import { ButtonGroup } from '../../../../common/buttons/ButtonGroup';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';
import { useWebhookUpdate } from '../hooks/useWebhookUpdate';

interface WebhookDisableModalProps {
    webhook: WebhookGatewayMessage;
    groupId: string;
    isOpen: boolean;
    onDismiss: () => void;
}

export const WebhookDisableModal = ({ webhook, groupId, isOpen, onDismiss }: WebhookDisableModalProps) => {
    const webhookUpdateMutation = useWebhookUpdate();
    const { addErrorToast } = useToasts();

    const handleDisableConfirm = () => {
        const webhookRequest = {
            name: webhook.name,
            url: webhook.url,
            groupId,
            customerIds: webhook.customerIds,
            resourceTypes: webhook.resourceTypes,
            enabled: false,
        };

        webhookUpdateMutation.mutate(
            { webhookId: webhook.id, webhook: webhookRequest },
            {
                onSuccess: () => {
                    onDismiss();
                },
                onError: () => {
                    addErrorToast(translate('global.genericToastError'));
                },
            }
        );
    };

    return (
        <Modal isOpen={isOpen} size="small" scrollable={false} onDismiss={onDismiss} dismissible={false}>
            <Box display="grid" gap={16} padding={24}>
                <Text variant="title">{translate('webhooks.disableConfirmPopup.disableDestination')}</Text>

                <Text variant="small" color="foreground.muted">
                    {translate('webhooks.disableConfirmPopup.text')}
                </Text>

                <ButtonGroup justifyContent="end">
                    <Button onClick={onDismiss}>{translate('btn.cancel')}</Button>
                    <Button emphasis="high" isLoading={webhookUpdateMutation.isPending} onClick={handleDisableConfirm}>
                        {translate('webhooks.disableConfirmPopup.disableDestination')}
                    </Button>
                </ButtonGroup>
            </Box>
        </Modal>
    );
};
